export default __webpack_public_path__ + "static/media/time-onclick.6b159dc7.svg";